(() => {
  if (window.__wwCollectionLegacySurfaceFix) return;
  window.__wwCollectionLegacySurfaceFix = true;

  const legacySelectors = [
    '#fdt-grid-container',
    'findter-search-filters',
    'fdt-search-filters',
    '.findter-search-filters',
    '.search-filters',
    'collection-component',
    'results-list.product-grid-container',
    '.section.product-grid-container',
  ];

  const removeLegacySurfaces = () => {
    if (!document.body) return;
    document.body.classList.add('ww-has-collection-landing');
    document.querySelectorAll(legacySelectors.join(',')).forEach((element) => {
      if (!element.closest('ww-collection-landing')) element.remove();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeLegacySurfaces, { once: true });
  } else {
    removeLegacySurfaces();
  }

  new MutationObserver(removeLegacySurfaces).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
